import { useMemo } from 'react';
import { usePermissions } from 'react-admin';
import { PERMISSIONS } from '../../constants';
import useDashboardContext from '../../hooks/useDashboardContext';
import Permission from '../../components/Permission';
import moment from 'moment';

import AvTimerIcon from '@mui/icons-material/AvTimer';
import { Box, Card, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const FillinDuration = () => {
  const { permissions } = usePermissions();
  // Usa dados do contexto (carregado pelo FillinsAverageTime)
  const { timeMetricsData } = useDashboardContext();

  // Deriva o valor formatado do contexto
  const time = useMemo(() => {
    if (!timeMetricsData?.duration) return '--:--:--';

    return moment('0:0:0', 'H:m:s')
      .add(timeMetricsData.duration.toFixed(2) * 60000, 'milliseconds')
      .format('HH:mm:ss');
  }, [timeMetricsData]);

  return (
    <Permission permission={PERMISSIONS.FILLIN_DURATION}>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          '& a': {
            textDecoration: 'none',
            color: 'inherit',
          },
        }}
      >
        <Link to="/your-link">
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              padding: '16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              '& .icon': {
                color: 'secondary.main',
              },
              '&:before': {
                position: 'absolute',
                top: '50%',
                left: 0,
                display: 'block',
                content: `''`,
                height: '200%',
                aspectRatio: '1',
                transform: 'translate(-30%, -60%)',
                borderRadius: '50%',
                backgroundColor: 'secondary.main',
                opacity: 0.15,
              },
            }}
          >
            <Box width="3em" className="icon">
              <AvTimerIcon fontSize="large" />
            </Box>
            <Box textAlign="right">
              <Typography color="textSecondary">Duração de um abastecimento</Typography>
              <Typography variant="h5" component="h2">
                {time}
              </Typography>
            </Box>
          </Box>
        </Link>
      </Card>
    </Permission>
  );
};
